<template>
  <div class="containerPolicy">
    <!-- <v-row class="d-flex justify-end mb-2" v-if="!isEditing">
      <v-col cols="12" md="auto" class="mb-6 myButtonPolicy">
        <BaseButton
          v-html="'EDITAR APÓLICE'"
          class="secondary"
          width="100%"
          @click="editPolicy"
          v-if="userIsEmployee"
        />
      </v-col>
    </v-row> -->
    <v-row class="mb-0">
      <v-spacer />
      <QuotationFloatActionButton
        v-if="enableAwaitingMessage && !this.userIsEmployee"
        :message="infoMessage"
      />
    </v-row>
    <QuotationBackButton
      @back="previousStep"
      class="buttonBack pb-2"
      v-if="this.form.numero_apolice == null || isEditing == true"
    />
    <QuotationProposalAwaitingMessage
      v-if="enableAwaitingMessage"
      message="Obrigado, estamos realizando a emissão da apólice."
    />
    <QuotationProposalViewer
      :isPolicy="true"
      :form="policyForm"
      :product="product"
      v-if="enableViewer"
    />
    <QuotationProposalForm
      :navigation-draft="navigationDraft"
      :isPolicy="true"
      ref="formEl"
      :form="policyForm"
      :headerText="stepText"
      :product="product"
      v-if="enableForm"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col
          cols="12"
          sm="5"
          md="3"
          class="pr-0 pr-sm-5 pb-5 pb-sm-0"
          v-if="isEditing || !hasPolicy"
        >
          <BaseButton
            v-html="'CANCELAR'"
            class="white--text pink"
            width="100%"
            @click="cancel()"
            v-if="isEditing && hasPolicy"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3" v-if="allowNext">
          <BaseButton
            v-html="stepText"
            class="white--text secondary"
            width="100%"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { formatDDMMYYYYToIsoDate } from "@/utils/formats.js";
import QuotationBackButton from "../components_agro/QuotationBackButton";
import QuotationProposalForm from "../components_agro/QuotationProposalForm.vue";
import QuotationProposalViewer from "../components_agro/QuotationProposalViewer.vue";
import QuotationProposalAwaitingMessage from "../components_agro/QuotationProposalAwaitingMessage.vue";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import PolicyMixin from "@/mixins/PolicyMixin";
import _ from "lodash";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";

export default {
  name: "QuotationStepPolicy",
  components: {
    QuotationProposalForm,
    QuotationProposalViewer,
    QuotationProposalAwaitingMessage,
    QuotationBackButton,
    QuotationFloatActionButton
  },
  mixins: [LoadingRequest, QuotationMixin, PolicyMixin],
  data() {
    return {
      formatDDMMYYYYToIsoDate,
      policyForm: null,
      isEditing: false
    };
  },
  created() {
    this.initializeForm();

    if (!this.policyForm.numero_apolice && this.userIsEmployee) {
      this.isEditing = true;
    }
  },
  methods: {
    getFormForNavigation() {
      return this.policyForm;
    },
    ...mapActions("quotation", [
      "submitPolicyDataAgro",
      "submitPolicyDataCafezal"
    ]),
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.policyForm, this.previousQuotationStep)
      );
    },
    editPolicy() {
      this.isEditing = true;
    },
    cancelEdit() {
      this.isEditing = false;
    },
    cancel() {
      this.isEditing = false;
    },
    async submit() {
      if (this.isEditing) {
        let validation = this.$refs.formEl.validate();
        if (validation === true) {
          // envia arquivos
          const form = await this.submitFormFiles(this.$refs.formEl.editForm);
          // envia alterações
          if (this.product == "agricola") {
            this.submitFormDataAgro(form);
          } else {
            this.submitFormDataCafezal(form);
          }
          this.$emit(
            "updateStep",
            this.payloadQuotation(this.policyForm, this.nextQuotationStep)
          );
        } else {
          this.showAlertNotification({
            message: validation,
            type: "error"
          });
        }
      } else {
        this.$emit(
          "updateStep",
          this.payloadQuotation(this.policyForm, this.nextQuotationStep)
        );
      }
    },
    async submitFormFiles(form) {
      let filesPolicy = await this.withLoading(
        this.submitFiles(form.arquivo_apolice)
      );

      if (filesPolicy != null && filesPolicy.length > 0) {
        form.arquivo_link = filesPolicy[0].url;
        form.arquivo_nome = filesPolicy[0].nome;
      }

      let filesBilling = await this.withLoading(
        this.submitFiles(form.arquivo_boleto)
      );

      if (filesBilling != null && filesBilling.length > 0) {
        form.boletos = filesBilling;
      }

      return form;
    },
    async submitFormDataAgro(form) {
      await this.withLoading(
        this.submitPolicyDataAgro(this.prepareProposalPayload(form)).then(
          value => {
            let policy = value.custos.find(
              x => x.numero_apolice != null && x.numero_apolice.length > 0
            );
            if (policy != null) {
              this.cloneProposal(policy);
              this.isEditing = false;
            }
          }
        )
      );
    },
    async submitFormDataCafezal(form) {
      await this.withLoading(
        this.submitPolicyDataCafezal(
          this.prepareProposalCafezalPayload(form)
        ).then(value => {
          let policy = value;
          if (policy != null) {
            this.cloneProposal(policy);
            this.isEditing = false;
          }
        })
      );
    },
    cloneProposal(proposal) {
      this.policyForm = _.cloneDeep(proposal);
      if (this.product == "agricola") {
        this.policyForm.tipo_seguro.nome =
          this.policyForm.tipo_seguro.nome ?? this.policyForm.tipo_seguro.name;
        this.policyForm.tipo_reivindicacao.nome =
          this.policyForm.tipo_reivindicacao.nome ??
          this.policyForm.tipo_reivindicacao.name;
        this.policyForm.tipo_cobertura.nome =
          this.policyForm.tipo_cobertura.nome ??
          this.policyForm.tipo_cobertura.name;
      }
      this.policyForm.forma_pagamento.nome =
        this.policyForm.forma_pagamento.nome ??
        this.policyForm.forma_pagamento.name;
    },
    prepareProposalPayload(payload) {
      return {
        id: payload.id,
        payload: {
          ...payload,
          inicio_vigencia: this.formatDDMMYYYYToIsoDate(
            payload.inicio_vigencia
          ),
          fim_vigencia: this.formatDDMMYYYYToIsoDate(payload.fim_vigencia),
          tipo_seguro_id: payload.tipo_seguro.id,
          tipo_cobertura_id: payload.tipo_cobertura.id,
          tipo_reivindicacao_id: payload.tipo_reivindicacao.id,
          forma_pagamento_id: payload.forma_pagamento.id
        }
      };
    },
    prepareProposalCafezalPayload(payload) {
      return {
        id: payload.id,
        payload: {
          ...payload,
          inicio_vigencia: this.formatDDMMYYYYToIsoDate(
            payload.inicio_vigencia
          ),
          fim_vigencia: this.formatDDMMYYYYToIsoDate(payload.fim_vigencia)
        }
      };
    },
    initializeForm() {
      if (this.form == null || this.form.id == null) {
        this.cloneProposal(this.formProposal);

        // se for clonado o form da proposta o arquivo não é o da apólice.
        this.policyForm.arquivo_link = null;
        this.policyForm.arquivo_nome = null;
        return;
      }

      this.cloneProposal(this.form);
    },
    parseCostsData(data, payment) {
      if (data == null) {
        return null;
      }

      if (data.tipo_seguro) {
        return _.cloneDeep(data);
      }

      return {
        id: data.id,
        numero_apolice: null,
        inicio_vigencia: null,
        fim_vigencia: null,
        tipo_seguro: {
          id: data.insuranceType.id,
          nome: data.insuranceType.nome
        },
        seguradora: data.insuranceCompany,
        area_segurada: data.insuredArea,
        tipo_reivindicacao: {
          id: data.claimType.id,
          nome: data.claimType.nome
        },
        tipo_cobertura: {
          id: data.coverage.id,
          nome: data.coverage.nome
        },
        importancia_segurada: data.insuredValue,
        producao_garantida: data.grantedProduction,
        custo_por_saca: data.costPerSac,
        custo_por_hectare: data.hectareCost,
        custo_total: data.total,
        subvencao_federal: data.federalSubvention,
        subvencao_estadual: data.stateSubvention,
        custo_segurado: data.insuredPrice,
        custo_produtor: data.farmerPrice,
        forma_pagamento: {
          id: payment ? payment.id : data.paymentForm.id,
          nome: payment ? payment.name : data.paymentForm.nome
        }
      };
    }
  },
  computed: {
    ...mapState("me", ["userIsEmployee", "myInfo"]),
    nextQuotationStep() {
      return {
        name: "quotation step policy",
        step: 11
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step agreement",
        step: 9
      };
    },
    hasPolicy() {
      return this.policyForm.numero_apolice != null;
    },
    enableForm() {
      return this.isEditing;
    },
    enableViewer() {
      return !this.isEditing && this.hasPolicy;
    },
    enableAwaitingMessage() {
      return !this.userIsEmployee && !this.hasPolicy;
    },
    allowNext() {
      return this.isEditing;
    },
    stepText() {
      return this.hasPolicy ? "SALVAR ALTERAÇÔES" : "INSERIR APÓLICE";
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    infoMessage() {
      return "Obrigado, estamos realizando a emissão da apólice. Em breve ela ficará disponível aqui.";
    }
  },
  props: {
    navigationDraft: {
      type: Object
    },
    form: {
      type: Object
    },
    formProposal: {
      type: Object
    },
    product: {
      type: String
    },
    formCosts: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.containerPolicy
  margin: 25px
  margin-top: 60px
.myButtonPolicy
  margin-top: -48px !important
  margin-bottom: 10px !important
  margin-right: -18px !important
.buttonBack
  margin-top: -55px !important
  margin-left: 15px !important
</style>
